import React, { useRef } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import Hammer from "hammerjs";
import zoomPlugin from "chartjs-plugin-zoom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin
);

export const options = {
  //   width: 839,
  plugins: {
    title: {
      display: true,
      text: "User Management",
    },
    zoom: {
      pan: {
        enabled: true,
        mode: "x",
      },
      zoom: {
        limits: {
          y: { min: 0, max: 100 },
          y2: { min: -5, max: 5 },
        },
        wheel: {
          enabled: true,
        },
        pinch: {
          enabled: true,
        },

        mode: "x",
      },
      rangeMin: {
        x: 2,
        y: 1,
      },
      rangeMax: {
        x: 10,
        y: 150,
      },
    },
  },
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  scales: {
    x: {
      stacked: true,
      maxTicksLimit: 11,
    },
    y: {
      stacked: true,
    },
  },
};

const labels = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30,
];

export const data = {
  labels,
  datasets: [
    {
      label: "Active",
      data: [
        65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81,
        56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 65, 59,
      ],
      backgroundColor: "rgb(0,0,135)",
      stack: "Stack 0",
    },
    {
      label: "Pending",
      data: [
        65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81,
        56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 65, 59,
      ],
      backgroundColor: "rgb(154,208,245)",
      stack: "Stack 0",
    },
    {
      label: "Rejected",
      data: [
        65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81,
        56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 65, 59,
      ],
      backgroundColor: "rgb(117,217,239)",
      stack: "Stack 1",
    },
  ],
};

export function MultiGraph() {
  const first = useRef(null);

  return (
    <div className="table-responsive">
      <Bar ref={first} options={options} data={data} />
    </div>
  );
}
